function helpers(quantity) {
  const quantityFormatted = quantity.replace(',', '.');

  return quantityFormatted;
}

export default helpers;